module.exports = "<div class=\"item\">\n    <slot></slot>\n  </div>";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.4@vue-html-loader!./~/.7.1.7@vue-loader/lib/selector.js?type=template&index=0!./src/Slider.vue
// module id = 195
// module chunks = 0